'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _middleware = require('../../middleware');

var _paths = require('./paths');

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

exports.default = function (feis_id, status) {
  return function (dispatch) {
    var actionTypes = ['GET_EVENTS_WITH_STATUS_START', 'GET_EVENTS_IN_RESULTS', 'GET_EVENTS_WITH_STATUS_ERROR'];

    return dispatch(_defineProperty({
      feis_id: feis_id,
      status: status

    }, _middleware.CALL_API, {
      config: {
        url: (0, _paths.feisPrefixUrl)(feis_id) + '/results-queue',
        method: 'GET'
      },
      types: actionTypes
    }));
  };
};


//////////////////
// WEBPACK FOOTER
// /Users/vidhigupta/isomorphic/lib/redux/actions/events/getEventsInResultsQueue.js
// module id = 638
// module chunks = 0